import { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext();
export const useCart = () => useContext(CartContext);

const getGuestCount = () => {
  try {
    const user = JSON.parse(localStorage.getItem("user") || "null");
    if (user?.access) return 0;
    const cart = JSON.parse(localStorage.getItem("a1_rugs_guest_cart") || "[]");
    return cart.reduce((sum, item) => sum + Number(item.quantity || 0), 0);
  } catch {
    return 0;
  }
};

export default function CartProvider({ children }) {
  const [cartCount, setCartCount] = useState(getGuestCount);

  useEffect(() => {
    const refresh = () => setCartCount(getGuestCount());
    window.addEventListener("guestCartUpdated", refresh);
    window.addEventListener("cartUpdated", refresh);
    window.addEventListener("storage", refresh);
    refresh();
    return () => {
      window.removeEventListener("guestCartUpdated", refresh);
      window.removeEventListener("cartUpdated", refresh);
      window.removeEventListener("storage", refresh);
    };
  }, []);

  return <CartContext.Provider value={{ cartCount, setCartCount }}>{children}</CartContext.Provider>;
}
